import { Company } from "@finway-group/shared/lib/models"
import { DatevOnlineConnectionStatusEnum } from "Features/settings/integration/datevOnlineSettings"
import { useSelector } from "react-redux"
import { RootState } from "Shared/store/rootState.interface"

export const useDatevOnlineConnected = () => {
    const company: any = useSelector(({ company: { item } }: RootState) => item)
    return company?.datevContext?.status === DatevOnlineConnectionStatusEnum.CONNECTED
}

export const useDatevOnlineError = () => {
    const company: any = useSelector(({ company: { item } }: RootState) => item)
    return company?.datevContext?.error
}

export const useCompany = () => useSelector(({ company: { item } }: RootState) => item)

export const useCompanies = (showDeleted = false) => {
    const items: Company[] = useSelector(({ company: { items } }: RootState) => items || [])
    if (showDeleted) return items

    return items.filter((item) => !item.deleted)
}

export const useCompanyById = (id: string) => {
    const items = useSelector(({ company: { items } }: RootState) => items || [])
    return items.find((item) => item._id === id)
}

export const useArchiveInterval = () => useSelector(({ company: { item } }: RootState) => item.archiveAfterXDays)
